import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { supabase } from '../services/supabase';

const PACKAGES = [
  {
    tier: 1,
    name: 'Starter',
    price: '₼75',
    period: '/ay',
    annual: 'İllik ödənişdə ₼720 — 2 ay pulsuz',
    popular: false,
    sections: [
      {
        label: 'Platform Varlığı',
        features: [
          { ok: true,  text: 'Platforma listinqi' },
          { ok: true,  text: 'Əsas profil (ad, ünvan, saatlar)' },
          { ok: true,  text: 'Menyu yükləmə' },
          { ok: true,  text: 'Foto qalereyası (maks 10 foto)' },
          { ok: false, text: 'Video / Professional çəkiliş' },
        ],
      },
      {
        label: 'Funksionallıq',
        features: [
          { ok: true,  text: 'Doluluk indikatoru (manual)' },
          { ok: false, text: 'Rezervasiya sistemi' },
          { ok: false, text: 'QR kupon / promo' },
          { ok: false, text: 'GastroMatch görünürlüyü' },
        ],
      },
      {
        label: 'Analitika & Dəstək',
        features: [
          { ok: true,  text: 'Əsas dashboard (baxış, klik)' },
          { ok: false, text: 'Dərin analitika' },
          { ok: true,  text: 'Email dəstək' },
        ],
      },
    ],
  },
  {
    tier: 2,
    name: 'Growth',
    price: '₼110',
    period: '/ay',
    annual: 'İllik ödənişdə ₼1,056 — 2 ay pulsuz',
    popular: true,
    sections: [
      {
        label: 'Platform Varlığı',
        features: [
          { ok: true, text: 'Platforma listinqi' },
          { ok: true, text: 'Tam profil + brend rəngi' },
          { ok: true, text: 'Menyu yükləmə + qiymət' },
          { ok: true, text: 'Foto qalereyası (maks 30 foto)' },
          { ok: true, text: '1 dəfə video çəkiliş (30 san. reel)' },
        ],
      },
      {
        label: 'Funksionallıq',
        features: [
          { ok: true, text: 'Doluluk indikatoru (real-time)' },
          { ok: true, text: 'Rezervasiya sistemi' },
          { ok: true, text: 'QR kupon / promo yaratma' },
          { ok: true, text: 'GastroMatch — artırılmış görünürlük' },
        ],
      },
      {
        label: 'Analitika & Dəstək',
        features: [
          { ok: true, text: 'Orta dashboard + müştəri davranışı' },
          { ok: true, text: 'Aylıq performans hesabatı' },
          { ok: true, text: 'Email + chat dəstək' },
        ],
      },
    ],
  },
  {
    tier: 3,
    name: 'Premium',
    price: '₼150',
    period: '/ay',
    annual: 'İllik ödənişdə ₼1,440 — 2 ay pulsuz',
    popular: false,
    sections: [
      {
        label: 'Platform Varlığı',
        features: [
          { star: true, text: 'Prioritet sıralama (axtarışda üst)' },
          { star: true, text: 'Tam profil + "Verified Partner" badge' },
          { star: true, text: 'Limitsiz foto qalereyası' },
          { star: true, text: 'Aylıq professional videoqraf çəkilişi' },
          { star: true, text: 'Turist paketi (multilanguage profil)' },
        ],
      },
      {
        label: 'Funksionallıq',
        features: [
          { star: true, text: 'Hər şey Growth\'da var +' },
          { star: true, text: 'GastroMatch — prioritet eşləşmə' },
          { star: true, text: 'Çox lokasiya dəstəyi' },
          { star: true, text: 'Xüsusi kampaniya & hadisə elanı' },
        ],
      },
      {
        label: 'Analitika & Dəstək',
        features: [
          { star: true, text: 'Tam analitika + export' },
          { star: true, text: 'Rəqib müqayisə hesabatı' },
          { star: true, text: 'Dedicated account manager' },
          { star: true, text: 'Aylıq 1-on-1 strateji görüş' },
        ],
      },
    ],
  },
];

export default function PackageSelectionPage() {
  const { business, refreshBusiness } = useAuth();
  const navigate = useNavigate();
  const [selecting, setSelecting] = useState(null);
  const [error, setError] = useState('');

  const handleSelect = async (pkg) => {
    setSelecting(pkg.tier);
    setError('');
    try {
      const { error: err } = await supabase
        .from('businesses')
        .update({ premium_tier: pkg.tier })
        .eq('id', business.id);

      if (err) throw err;
      await refreshBusiness();
      navigate('/dashboard');
    } catch (e) {
      setError('Xəta baş verdi. Yenidən cəhd edin.');
      setSelecting(null);
    }
  };

  return (
    <div style={s.page}>
      <div style={s.header}>
        <div style={s.logoRow}>
          <span style={s.logoText}>Cafegoo</span>
          <span style={s.logoBiz}>Biznes</span>
        </div>
        <h1 style={s.title}>Paket seçin</h1>
        <p style={s.subtitle}>
          İşinizi böyütmək üçün sizə uyğun planı seçin.<br />
          İstənilən vaxt dəyişdirə bilərsiniz.
        </p>
      </div>

      {error && <div style={s.errorBar}>{error}</div>}

      <div style={s.cards}>
        {PACKAGES.map((pkg) => (
          <div
            key={pkg.tier}
            style={{ ...s.card, ...(pkg.popular ? s.cardPopular : {}) }}
          >
            {pkg.popular && <div style={s.badge}>✦ MƏSLƏHƏTLİ</div>}

            <div style={s.planName}>{pkg.name}</div>
            <div style={s.price}>
              {pkg.price} <span style={s.pricePeriod}>{pkg.period}</span>
            </div>
            <div style={s.annual}>{pkg.annual}</div>

            {pkg.sections.map((sec, si) => (
              <div key={si}>
                <hr style={si === 0 ? { ...s.divider, marginTop: 4 } : s.divider} />
                <div style={s.secLabel}>{sec.label}</div>
                <ul style={s.featureList}>
                  {sec.features.map((f, fi) => (
                    <li key={fi} style={{ ...s.featureItem, ...(f.ok === false ? s.featureOff : {}) }}>
                      <span style={f.star ? s.iconStar : f.ok ? s.iconCheck : s.iconCross}>
                        {f.star ? '★' : f.ok ? '✓' : '✗'}
                      </span>
                      {f.text}
                    </li>
                  ))}
                </ul>
              </div>
            ))}

            <button
              style={{
                ...s.btn,
                ...(pkg.popular ? s.btnFill : s.btnOutline),
                ...(selecting === pkg.tier ? s.btnDisabled : {}),
              }}
              onClick={() => handleSelect(pkg)}
              disabled={!!selecting}
            >
              {selecting === pkg.tier ? 'Seçilir...' : 'Bu planı seç'}
            </button>
          </div>
        ))}
      </div>

      <p style={s.note}>
        Ödəniş sistemi tezliklə aktiv olacaq. Hal-hazırda seçim qeyd edilir.
      </p>
    </div>
  );
}

const ORANGE = '#f97316';

const s = {
  page: {
    minHeight: '100vh',
    background: '#0f0f0f',
    color: '#fff',
    fontFamily: "'Segoe UI', sans-serif",
    padding: '40px 20px 60px',
    boxSizing: 'border-box',
  },
  header: { textAlign: 'center', marginBottom: 36 },
  logoRow: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, marginBottom: 20 },
  logoText: { fontSize: 26, fontWeight: 800, color: ORANGE, letterSpacing: -1 },
  logoBiz: {
    fontSize: 12, fontWeight: 700, color: '#fff',
    background: 'rgba(249,115,22,0.2)', borderRadius: 6,
    padding: '2px 8px', letterSpacing: 1,
  },
  title: { fontSize: 28, fontWeight: 700, margin: '0 0 10px', letterSpacing: 0.5 },
  subtitle: { color: '#888', fontSize: 14, lineHeight: 1.7, margin: 0 },

  errorBar: {
    background: '#ff4444', color: '#fff', borderRadius: 8,
    padding: '10px 18px', maxWidth: 700, margin: '0 auto 20px',
    textAlign: 'center', fontSize: 14,
  },

  cards: {
    display: 'flex',
    gap: 20,
    maxWidth: 1020,
    margin: '0 auto',
    alignItems: 'stretch',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },

  card: {
    flex: '1 1 280px',
    maxWidth: 320,
    borderRadius: 16,
    padding: '28px 24px',
    border: '1px solid #222',
    background: '#161616',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    boxSizing: 'border-box',
  },
  cardPopular: {
    borderColor: ORANGE,
    background: '#1a1208',
    transform: 'translateY(-8px)',
  },

  badge: {
    position: 'absolute',
    top: -13,
    left: '50%',
    transform: 'translateX(-50%)',
    background: ORANGE,
    color: '#fff',
    fontSize: 11,
    fontWeight: 700,
    padding: '4px 14px',
    borderRadius: 20,
    letterSpacing: 1,
    whiteSpace: 'nowrap',
  },

  planName: { fontSize: 13, fontWeight: 600, color: '#888', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 8 },
  price: { fontSize: 36, fontWeight: 700, color: '#fff', marginBottom: 2 },
  pricePeriod: { fontSize: 16, color: '#888', fontWeight: 400 },
  annual: { fontSize: 12, color: ORANGE, marginBottom: 16 },

  divider: { border: 'none', borderTop: '1px solid #222', margin: '14px 0' },
  secLabel: { fontSize: 10, fontWeight: 700, letterSpacing: 2, color: '#555', textTransform: 'uppercase', marginBottom: 8, marginTop: 4 },

  featureList: { listStyle: 'none', padding: 0, margin: '0 0 4px', flex: 1 },
  featureItem: { fontSize: 13, color: '#ccc', padding: '5px 0', display: 'flex', alignItems: 'flex-start', gap: 8, lineHeight: 1.4 },
  featureOff: { color: '#444' },
  iconCheck: { color: '#22c55e', flexShrink: 0, marginTop: 1 },
  iconCross: { color: '#333', flexShrink: 0, marginTop: 1 },
  iconStar: { color: ORANGE, flexShrink: 0, marginTop: 1 },

  btn: {
    marginTop: 24,
    width: '100%',
    padding: '13px',
    borderRadius: 10,
    border: 'none',
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 700,
    transition: 'all .2s',
    letterSpacing: 0.3,
  },
  btnOutline: { background: 'transparent', border: '1px solid #333', color: '#ccc' },
  btnFill: { background: ORANGE, color: '#fff' },
  btnDisabled: { opacity: 0.6, cursor: 'not-allowed' },

  note: { textAlign: 'center', color: '#444', fontSize: 12, marginTop: 32 },
};
